import React, { useState, useRef, useEffect, FC } from 'react';
import { useTranslation } from '../i18n';
import { Globe, ChevronDown } from 'lucide-react';

const LanguageSwitcher: FC = () => {
    const { language, setLanguage, t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const languages: { [key: string]: string } = {
        en: t('english'),
        ku: t('kurdish'),
        ar: t('arabic')
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    
    return (
        <div ref={wrapperRef} className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-1.5 p-2 rounded-lg text-slate-600 hover:bg-slate-100 hover:text-primary-600 transition-colors duration-200"
                aria-haspopup="true"
                aria-expanded={isOpen}
            >
                <Globe size={20} />
                <span className="font-medium text-sm hidden sm:inline">{language.toUpperCase()}</span>
                <ChevronDown
                  size={16}
                  className={`text-slate-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>
            {isOpen && (
                <div className="absolute top-full end-0 mt-2 w-36 bg-white rounded-lg shadow-xl p-1 z-50 border border-slate-100">
                    {Object.entries(languages).map(([code, name]) => (
                         <button
                            key={code}
                            onClick={() => { setLanguage(code); setIsOpen(false); }}
                            className={`w-full text-start px-3 py-2 rounded-md text-sm ${language === code ? 'bg-primary-50 text-primary-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`}
                        >
                            {name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
